module.exports = __webpack_public_path__ + "img/visa.b1684820.svg";